<template>
  <div class="h-screen w-screen overflow-x-hidden">
    <router-view></router-view>
  </div>
</template>
<script setup lang="ts">
</script>